import React, { useEffect, useState } from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import InfoIcon from "@mui/icons-material/Info";

const CustomObjectFieldTemplate = (props) => {
  const { properties, formContext } = props;
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    setActiveTab(properties[0].name);
  }, []);

  const handleTabChange = (tabName) => {
    const errPath = formContext.rootPath;
    for (let itm in properties) {
      if (
        properties[itm].name === activeTab &&
        errPath?.indexOf(properties[itm].content.props.idSchema["$id"]) === 0
      ) {
        // alert(errPath + " empty or incorrect.");
        const inputElement = document.getElementsByName(errPath)[0];
        if (inputElement) {
          inputElement.focus();
        }
        return;
      }
    }
    setActiveTab(tabName);
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex" }}>
        <h2>{props.title}</h2>
        <InfoIcon />
      </div>
      <h5>{props.description}</h5>
      <Tabs activeKey={activeTab} onSelect={handleTabChange} id="form-tabs" style={{ width: "100%" }}>
        {properties.map((element, index) => (
          <Tab
            key={index}
            eventKey={element.name}
            title={element.content.props.schema.title}
          >
            <div style={{ width: "100%" }}>
            {element.content}
            </div>
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomObjectFieldTemplate;
